// Layout: Content with Image Rows
document.addEventListener("DOMContentLoaded", function () {
	const jumpLinks = document.querySelectorAll(
		".content-with-image-rows__jump-links a[href^='#']"
	);

	jumpLinks.forEach(function (link) {
		link.addEventListener("click", function (e) {
			e.preventDefault();
			const targetId = this.getAttribute("href").substring(1);
			const targetEl = document.getElementById(targetId);

			if (targetEl) {
				targetEl.scrollIntoView({ behavior: "smooth", block: "start" });
				history.pushState(null, null, "#" + targetId);
			}
		});
	});
});
